
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCcw } from 'lucide-react';

interface RefreshDataButtonProps {
  onClick: () => void;
  isRefreshing: boolean;
}

const RefreshDataButton: React.FC<RefreshDataButtonProps> = ({ 
  onClick, 
  isRefreshing 
}) => {
  return (
    <Button 
      variant="outline" 
      size="sm" 
      className="gap-2"
      onClick={onClick}
      disabled={isRefreshing}
    >
      <RefreshCcw size={16} className={isRefreshing ? "animate-spin" : ""} />
      Refresh Data
    </Button>
  );
};

export default RefreshDataButton;
